<template>
  <div>
    <div class="container">
      <!-- BEGIN: Error Page -->
      <div
        class="error-page flex flex-col lg:flex-row items-center justify-center h-screen text-center lg:text-left"
      >
        <div class="text-white container mt-10 lg:mt-0">
          <div class="intro-x text-4xl font-medium">
            AutismOklahoma Walk {{ appYear }}
          </div>
          <div class="intro-x text-2xl font-medium">
            Thanks for a great event! We are looking forward to seeing you next
            year!
          </div>
        </div>
      </div>
      <!-- END: Error Page -->
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, computed } from "vue";

import { useStore } from "@/store";

export default defineComponent({
  components: {},
  setup() {
    const store = useStore();
    const appYear = computed(() => store.getters["main/appYear"]);
    onMounted(() => {
      cash("body")
        .removeClass("main")
        .removeClass("login")
        .addClass("error-page");
    });
    return { appYear };
  }
});
</script>
